import { Component, OnInit, Input, Renderer2 } from '@angular/core';
import { LaunchWallboardService } from './launch-wallboard.service';
import { NavigationService } from 'src/app/navigation/navigation.service';
import { WallboardGridster, WallboardSlideGridster } from '../../wallboards/wallboards.model';

@Component({
    selector: 'cvLaunchWallboard',
    templateUrl: './launch-wallboard.component.html',
    styleUrls: ['./launch-wallboard.component.scss']
})
export class LaunchWallboardComponent implements OnInit {
    public isLoading: boolean;
    public isRefreshing: boolean;
    public wallboards: WallboardGridster[];
    public folders: string[];
    public selectedWallboard: WallboardGridster;

    public filterText = "";
    public refreshPreview: boolean = false;

    public loadedWallboards: WallboardGridster[] = [];

    @Input() isCxone: boolean = true;

    get WallboardsFiltered(): WallboardGridster[] {
        if (this.filterText == "")
            return this.wallboards;

        let filteredWallboards = this.wallboards.filter(o => o.WallboardName.toLowerCase().includes(this.filterText.toLowerCase())) ?? [];
        if (filteredWallboards.length == 0)
            this.selectedWallboard = null;

        return filteredWallboards;
    }
    get MostRecentWallboardsFiltered(): WallboardGridster[] {
        // NOTE: Right now, this is returning the most recent wallboards after filtering, which means that it can return older ones if they match the filtering and newer ones do not.
        // To change it so that this section will only ever show the five most recent that also pass the filter, change "WallboardsFiltered" to "wallboards" in the line below
        // and filter after slicing.
        return this.WallboardsFiltered.filter(o => o.LastViewed).sort((a, b) => a.LastViewed < b.LastViewed ? 1 : -1).slice(0, 5) ?? [];
    }
    get FoldersFiltered(): string[] {
        if (this.filterText == "")
            return this.folders;

        return this.folders.filter(o => this.WallboardsFiltered.map(o => o.WallboardGroup.toLowerCase()).includes(o.toLowerCase())) ?? [];
    }

    constructor(
        public navigationService: NavigationService,
        public launchWallboardService: LaunchWallboardService,
        private renderer: Renderer2
    ) { }

    async ngOnInit() {
        try {
            this.isLoading = true;
            const apiModel = await this.launchWallboardService.loadWallboards();

            this.wallboards = apiModel.Wallboards as WallboardGridster[];
            // Sets all folder names to uppercase and removes any duplicates this action creates
            this.folders = [...new Set(apiModel.Folders.map(o => o.toUpperCase()))];
        }
        catch (error) {
            console.log(error);
        }
        finally {
            this.isLoading = false;

            if (this.isCxone) {
                this.renderer.setStyle(document.body, 'background-color', 'white');
              }
        }
    }

    ngOnDestroy(): void {
        this.renderer.removeStyle(document.body, 'background-color');
      }
      
    /**
     * Returns all wallboards in the specified folder (after filtering).
     * @param folder Name of folder
     */
    public wallboardsInFolderFiltered(folder: string): WallboardGridster[] {
        return this.WallboardsFiltered.filter(o => o.WallboardGroup.toLowerCase() == folder.toLowerCase()) ?? [];
    }

    /**
     * Selects the specified wallboard and, if necessary, pulls its slides from the server and sets them to the wallboard.
     * @param wallboard Wallboard to select
     */
    public async selectWallboard(wallboard: WallboardGridster) {
        if (!wallboard.Slides) {
            try {
                wallboard.Slides = (await this.launchWallboardService.loadIndividualWallboard(wallboard.WallboardID) as WallboardSlideGridster[]).filter(o => o.Enabled);

                // This ensures that we only hold onto the data for the last 10 wallboards that have slides that have been loaded
                if (wallboard.Slides.length > 0 && !this.loadedWallboards.includes(wallboard)) {
                    if (this.loadedWallboards.length == 10) {
                        let oldestLoadedWallboard = this.loadedWallboards.shift();
                        oldestLoadedWallboard.Slides = null;
                    }

                    this.loadedWallboards.push(wallboard);
                }
            }
            catch (error) {
                console.log(error);
            }
        }
        this.selectedWallboard = wallboard;

        if (this.selectedWallboard.Slides.length > 0) {
            this.refreshPreview = false;
            setTimeout(() => {
                this.refreshPreview = true;
            });
        }
    }

    public async refreshWallboard(wallboard: WallboardGridster) {
        wallboard.Slides = this.selectedWallboard.Slides;
        this.isRefreshing = true;
        try {
            wallboard.Slides = (await this.launchWallboardService.loadIndividualWallboard(wallboard.WallboardID) as WallboardSlideGridster[]).filter(o => o.Enabled);
        }
        catch (error) {
            console.log(error);
        }
        if (this.selectedWallboard.Slides.length > 0) {
            this.refreshPreview = false;
            setTimeout(() => {
                this.refreshPreview = true;
                this.isRefreshing = false;
            });
        }
    }
}
